import React, { useEffect, useState } from 'react';
import GridInputs from '../../../../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../../../../components/common/button/CustomButtons';
import useConfirm from '../../../../../components/common/useConfirm';
import GridDatePicker from '../../../../../components/common/inputs/GridDatePicker';
import moment from 'moment';
import AutocompleteGridmui from '../../../../../components/common/autocomplete/AutocompleteGridmui';

const ModalInput = ({
  id,
  setIsModal,
  setListId,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setListId: any;
}) => {
  const [moduleData, setMoudleData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [render, setRender] = useState(false);
  const [category, setCategory] = useState([]);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update' : 'Create'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`,
  );

  useEffect(() => {
    axios
      .get(
        `/api/masterSkillEvaluationCategoryRoute/skillList/categoryForAutoComplete`,
      )
      .then((res) => setCategory(res.data))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/skillMatrixRoute/${id}`)
        .then((res) => setMoudleData(res.data))
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleData(e: React.ChangeEvent<HTMLInputElement>) {
    setMoudleData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  const handleSumbit = async () => {
    setIsLoading(true);
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/skillMatrixRoute/${id}`, moduleData)
        .then((res) => {
          setIsLoading(false);
          setIsModal(false);
          setListId('');
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post(`/api/skillMatrixRoute`, moduleData)
        .then((res) => {
          setIsLoading(false);
          setIsModal(false);
          setListId('');
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <GridInputs
        id={'title'}
        name={'title'}
        html_for={'title'}
        label_name={'Title'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.title || ''}
        onChange={handleData}
      />
      {!id && (
        <AutocompleteGridmui
          label={'Cateogry'}
          id={'name'}
          option_name={'name'}
          value={moduleData.category_id_temp || moduleData?.category_id || ''}
          arrayofObj={category}
          onChange={(e, value) => {
            moduleData.category_id = value?._id;
            moduleData.category_id_temp = value;
            setRender((prev) => !prev);
          }}
        />
      )}
      <GridDatePicker
        label_name="Date"
        html_for={'date_range'}
        views={['year']}
        value={moduleData?.date_range || null}
        onChange={(date) => {
          moduleData.date_range = moment(date._d).add(10, 'hours');
          setRender((prev) => !prev);
        }}
      />
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default ModalInput;
